<template>
    <div class="header-warp">
        <header
                id="subHeader"
                class="header">
            <h1 >{{ title }}</h1>
            <span
                    class="back"
                    @click="goBack" />
        </header>
    </div>
</template>

<script>
  // import NativeAPI from 'native-api'
  import NativeSdk from "@/utils/nativeSdk"

  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    data() {
      const isApp = navigator.userAgent.indexOf('chesupai') > -1 || navigator.userAgent.indexOf('chesuda') > -1 || navigator.userAgent.indexOf('Guazi') > -1
      return {
        isApp: !!isApp,
      }
    },
    created() {
      this.initData()
    },
    methods: {
      initData() {
        if (this.isApp) {
          // 使用统一方案：当webview back之前
        //   NativeAPI.onWebviewBeforeBack({ status: false, customResponseData: true }, (res, responseCallback) => {
        //     const lastPage = window.location.href
        //     window.history.back()
        //     setTimeout(() => {
        //       if (window.location.href === lastPage) {
        //         responseCallback({ preventDefault: false })
        //       }
        //     }, 300)
        //   })
        }
      },
      goBack() {
        if (this.isApp) {
          // 注册back方法
            const lastPage = window.location.href
            this.$router.go(-1)
            setTimeout(() => {
                if (window.location.href === lastPage) {
                    // 兼容物流app
                        // NativeAPI.invoke('back')
                     NativeSdk.back();
                }
            }, 300)
          // 调用返回
          // NativeAPI.invoke('back')
        } else {
          this.$router.go(-1)
        }
      },
    },
  }
</script>

<style scoped lang="less">
@import "./index";
</style>
